<template>
  <div class="edit-chart" v-if="isLoaded">
    <div class="edit-chart__header">
      {{$t('feed.analytics.edit.caption')}}
    </div>

    <el-tabs class="edit-chart" :value="activeName" @tab-click="handleClick">
      <el-tab-pane v-for="(item, key) in tabs" :label="item" :name="key" :key="key">
        <chart-table :data="data[key]" :chart-key="key" :chart-name="chartName"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
/*edit chart component for analytics charts*/

//config
import sourceShortcuts from "../../../../config/sourceShortcuts";

// vuex
import { mapGetters } from "vuex";

//components
import ChartTable from "./table/ChartTable";

export default {
  name: "EditChart",
  props: {
    chartName: {
      type: String
    }
  },
  computed: {
    ...mapGetters([
      "socialList",
    ]),
    tabs() {
      let socials = this.$t('feed.analytics.edit.table.source');
      let tabs = {};

      Object.entries(socials).forEach(item => {
        if(this.socialList.includes(item[0])){
          tabs[item[0]] = item[1];
        }
      });

      return tabs;
    },
    isLoaded() {
      return this.$store.getters.isLoaded(this.chartName);
    },
    data() {
      return this.$store.getters.chartData(this.chartName);
    },
    sources() {
      let sourceOf = [];
      let sourceShortcuts = this.$t('feed.analytics.edit.table.source');

      if (Object.keys(this.data).length) {
        Object.entries(sourceShortcuts).forEach(shortcut => {
          if(this.data[shortcut[0]]) {
            sourceOf[shortcut[0]] = shortcut[1];
          }
        });
      }

      return  sourceOf;
    },
    activeName() {
      return Object.entries(this.tabs)[0][0];
    },
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  },
  components: {
    ChartTable
  }
};
</script>

<style>
  .edit-chart__header {
    margin-bottom: 55px;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    color: #000000;
  }
  @media screen and (max-width: 480px) {
    .edit-chart .el-tabs__nav-wrap{
      display: block;
    }
  }
</style>
